import { render, staticRenderFns } from "./AdvertisingCard.vue?vue&type=template&id=0d005cf2&scoped=true"
import script from "./AdvertisingCard.vue?vue&type=script&lang=js"
export * from "./AdvertisingCard.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingCard.vue?vue&type=style&index=0&id=0d005cf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d005cf2",
  null
  
)

export default component.exports